import GroupedByFirstLetterList from './groupedByFirstLetterList';

export default GroupedByFirstLetterList;
